var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIbex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 207.88 49.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{stroke:#fff;stroke-miterlimit:10;stroke-width:1.82px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.46.14C20.17.54,0,5.38,0,5.38l3.22,7.26,26.3,6V0A42.13,42.13,0,0,0,24.46.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.42,12.44l3-7.06S40.54.74,37.33.54c-2-.13-4.89-.41-7.81-.51V18.62l.3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.25,34.41,46.34,31s9-14.93,8.58-14.93-21.67,5.21-25.4,6.12v12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.5,15.66c-.42.61,8.59,15.53,8.59,15.53l16.43,3.09V22.18l-.56.14S4.93,15.06,4.5,15.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36,46.51c3.21-3.22,9-11.29,8.15-11.69s-13.1,2.61-14.65,3V49.35A8.38,8.38,0,0,0,36,46.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.21,34.62c-.43.4,3,5.84,4.93,8.87,2.57,4,7.72,5.84,8.8,5.84l.58,0V37.8l-.15,0S15.64,34.21,15.21,34.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.91,6.16V43.72H72V6.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.1,43.72V6.16h19.13q8,0,10.4,1.9t2.46,8q0,6.24-5.55,7.89v.09q6.87,1.43,6.88,8.83c0,4-.91,6.78-2.71,8.39s-4.95,2.42-9.42,2.42Zm4.88-21H107.8q6.12,0,7.87-1.26t1.76-5.64c0-2.54-.51-4.17-1.53-4.92s-3.28-1.11-6.77-1.11H95Zm0,17.47h10.35l4.41,0q5.57,0,7.29-1.26c1.16-.83,1.73-2.6,1.73-5.29q0-5-1.74-6.18t-9.47-1.14H95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.13,9.74V22.53h21.94v3.58H138.13v14H161v3.58H133.25V6.16H161V9.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205,6.16,191.19,24.3,206,43.72h-5.76l-10-13.15-1.58-2.07c-.09-.1-.33-.44-.73-1l-.76-1h-.13l-.76,1.07c-.42.54-.68.89-.79,1l-1.65,2.09L173.71,43.72h-6L183.18,24.3,169,6.16h5.89l9.59,12.52,1.33,1.76.67.88.63.88h.13l.63-.85c.34-.49.55-.79.63-.88l1.3-1.73,9.47-12.58Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIbex);
export default __webpack_public_path__ + "static/media/logo-ibex.ae7a64db7423f70011846697e060f07f.svg";
export { ForwardRef as ReactComponent };